import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { markMentionRead } from './api';
export function TeamMentionContext() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const id = params.get('_teamMention');
  const target = params.get('_target');
  const ready = useSelector((state: any) =>
    state.teams?.teamConversations
      ?.find((c: any) => c._id === state.teams?._activeTeamConversation)
      ?.teamMessages?.some((m: any) => m._id === target && !m.isDeleted),
  );
  const [error, setError] = useState('');
  useEffect(() => {
    setError('');
    if (!id) return;
    if (!ready || !target) {
      navigate(`/team-mentions/${encodeURIComponent(id)}`, { replace: true });
      return;
    }
    let active = true;
    let opened = false;
    const reveal = () => {
      const element = document.getElementById(target);
      if (opened || !element || !element.getBoundingClientRect().height) return;
      opened = true;
      element.scrollIntoView({ block: 'center' });
      markMentionRead(id, true).catch(() => {
        if (active)
          setError(
            'The message opened, but could not be marked read. Reopen the mention to retry.',
          );
      });
    };
    const observer = new MutationObserver(reveal);
    observer.observe(document.body, { childList: true, subtree: true });
    const timer = setTimeout(reveal, 150);
    return () => {
      active = false;
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [id, target, ready, navigate]);
  return error ? (
    <p role="alert" className="bg-background p-3 text-sm text-destructive">
      {error}
    </p>
  ) : null;
}
